import HeroB2B from "./HeroB2B";
import HeroB2C from "./HeroSection";

const Hero = window.dataGlobalSettings.siteType === 3 ? HeroB2B : HeroB2C;

export default Hero;
